"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _testForPassiveScroll = _interopRequireDefault(require("../../utils/testForPassiveScroll"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const ParallaxController = props => {
  // TODO Optimize this logic - look into dumping the event listener and just using setInterval/requestAnimationFrame instead

  (0, _react.useEffect)(() => {
    let debounceTimer;
    const updateOffsetY = () => {
      props.updateOffsetY(window.pageYOffset);
    };
    const supportsPassive = (0, _testForPassiveScroll.default)();
    // checks to see if the browser supports passive scroll, an optmization technique

    const exectureParallax = () => {
      if (debounceTimer) {
        window.clearTimeout(debounceTimer);
      }
      debounceTimer = window.setTimeout(requestID = window.requestAnimationFrame(updateOffsetY), 16);
    };
    let requestID;
    window.addEventListener("scroll", exectureParallax, supportsPassive ? {
      passive: true
    } : false);
    updateOffsetY();
    return () => {
      window.removeEventListener("scroll", updateOffsetY(), supportsPassive ? {
        passive: true
      } : false);
      if (debounceTimer) {
        window.clearTimeout(debounceTimer, 16);
      }
      window.cancelAnimationFrame(requestID);
    };
  }, []);
  return null;
};
var _default = ParallaxController;
exports.default = _default;